import React from "react";

import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import Image from "next/image";
import Link from "next/link";
import IconCode from "@/src/lib/iconCode";
import Iconify from "@/src/components/iconify";

const CopyrightSection = () => {
    return (
        <>
            <div
                component="div"
                className="py-8 border-dashed border-t-2 mt-5 text-bold border-slate-500"
            >
                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-2 items-center">
                    <div className="col-span-12 md:col-span-3 flex justify-center md:justify-start">
                        <Link href="/" title="House Of Diagnostics">
                            <Image
                                src={`${NEXT_IMAGE_CDN}/icon/hod_logo.svg`}
                                alt="House Of Diagnostics"
                                width={0}
                                height={0}
                                className="mx-auto md:mx-0 cursor-pointer w-32 h-12 object-contain"
                                sizes="(max-width: 768px) 100vw, 33vw"
                            />
                        </Link>
                    </div>
                    <div className="col-span-12 md:col-span-5 text-center md:text-left">
                        <p className="text-black leading-none text-sm pt-4 md:pt-0">
                            House Of Diagnostics - Copyrights{" "}
                            {new Date().getFullYear()}, All Rights Reserved
                        </p>
                    </div>
                    <div className="col-span-12 md:col-span-4 text-center md:text-center">
                        <p className="text-black text-md font-semibold mb-2 md:mb-1">
                            Follow Us
                        </p>
                        <div className="flex flex-row flex-wrap gap-3 justify-center">
                            <Link
                                aria-label="facebook"
                                href="https://www.facebook.com/HouseOfDiagnostics/"
                                title="HOD Facebook"
                            >
                                <Iconify
                                    icon={IconCode.facebook}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>
                            <Link
                                aria-label="X"
                                href="https://x.com/hodcare"
                                title="HOD X Handle"
                            >
                                <Iconify
                                    icon={IconCode.twitter}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>

                            <Link
                                aria-label="instagram"
                                href="https://www.instagram.com/houseofdiagnosticsofficial/?hl=en"
                            >
                                <Iconify
                                    icon={IconCode.instagram}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>

                            <Link
                                aria-label="youtube"
                                href="https://www.youtube.com/c/Houseofdiagnostics/videos"
                            >
                                <Iconify
                                    icon={IconCode.youtube}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>

                            <Link
                                aria-label="pinterest"
                                href="https://in.pinterest.com/houseofdiagnostics/"
                            >
                                <Iconify
                                    icon={IconCode.pinterest}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>
                            <Link
                                aria-label="linkedin"
                                href="https://in.linkedin.com/company/house-of-diagnostics"
                            >
                                <Iconify
                                    icon={IconCode.linkedin}
                                    width={30}
                                    className="text-primary"
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CopyrightSection;
